import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminDashboard.css';
import { usePagination } from '../../context/PaginationContext';
const AdminDashboard = () => {
  const [tools, setTools] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredTools, setFilteredTools] = useState([]);

  const [showAddForm, setShowAddForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const { refreshTools } = usePagination();
  const [addData, setAddData] = useState({
    name: '', description: '', category: '', logo: '',
    website: '', isFree: true, howToUse: '', whatItDoes: '', demoVideo: ''
  });

  const [updateData, setUpdateData] = useState({
    id: '', name: '', description: '', category: '', logo: '',
    website: '', isFree: '', howToUse: '', whatItDoes: '', demoVideo: ''
  });

  const [deleteId, setDeleteId] = useState('');

  // Fetch tools
  const fetchTools = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/tools`);
      setTools(res.data);
      setFilteredTools(res.data);
      setSearchQuery('');
    } catch (err) {
      console.error('Failed to fetch tools:', err);
    }
  };

  useEffect(() => {
    fetchTools();
  }, []);

  // Search logic
  useEffect(() => {
    const q = searchQuery.toLowerCase();
    const result = tools.filter(tool =>
      tool._id.toLowerCase().includes(q) || tool.name.toLowerCase().includes(q)
    );
    setFilteredTools(result);
  }, [searchQuery, tools]);

  // Add Tool
  const handleAddTool = async () => {
    const payload = {
      ...addData,
      howToUse: addData.howToUse.split(',').map(s => s.trim()),
    };
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/tools`, payload);
       fetchTools();
      await refreshTools();
      setAddData({ name: '', description: '', category: '', logo: '', website: '', isFree: true, howToUse: '', whatItDoes: '', demoVideo: '' });
      setShowAddForm(false);
    } catch (err) {
      console.error('Add failed:', err);
    }
  };

  // Update Tool
  const handleUpdateTool = async () => {
    const { id, ...fields } = updateData;
    const payload = {};
    for (let key in fields) {
      if (fields[key] !== '') {
        payload[key] = key === 'howToUse'
          ? fields[key].split(',').map(s => s.trim())
          : fields[key];
      }
    }
    try {
      await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/api/tools/${id}`, payload);
      await fetchTools();
      await refreshTools();
      setUpdateData({ id: '', name: '', description: '', category: '', logo: '', website: '', isFree: '', howToUse: '', whatItDoes: '', demoVideo: '' });
      setShowUpdateForm(false);
    } catch (err) {
      console.error('Update failed:', err);
    }
  };

  // Delete Tool
  const handleDeleteTool = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/tools/${deleteId}`);
    //   setTools(res.data);
      await fetchTools();
      await refreshTools();
      setDeleteId('');
      setShowDeleteForm(false);
    } catch (err) {
      console.error('Delete failed:', err);
    }
  };

  return (
    <div className="admin-dashboard">
      <h2> Admin Tool Management</h2>
      <div className="mobile-warning">
      For the best experience and all features, please use a PC or laptop
      </div>
      {/* Top Buttons + Search */}
      <div className="admin-actions">
        <button onClick={() => setShowAddForm(!showAddForm)}>➕ Add Tool</button>
        <button onClick={() => setShowUpdateForm(!showUpdateForm)}>✏️ Update Tool by ID</button>
        <button onClick={() => setShowDeleteForm(!showDeleteForm)}>🗑️ Delete Tool by ID</button>
        <input
          type="text"
          placeholder="🔍 Search by ID or name"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Add Tool Form */}
      {showAddForm && (
        <div className="form-container">
          <h4>➕ Add Tool</h4>
          {Object.keys(addData).map((key) => {
            if (key === 'isFree') {
              return (
                <label key={key}>
                  <input
                    type="checkbox"
                    checked={addData[key]}
                    onChange={(e) =>
                      setAddData(prev => ({
                        ...prev,
                        [key]: e.target.checked
                      }))
                    }
                  />
                  Is Free
                </label>
              );
            }
            return (
              <input
                key={key}
                type="text"
                placeholder={key}
                value={addData[key]}
                onChange={(e) =>
                  setAddData(prev => ({
                    ...prev,
                    [key]: e.target.value
                  }))
                }
              />
            );
          })}
          <button onClick={handleAddTool}>Add Tool</button>
        </div>
      )}

      {/* Update Tool Form */}
      {showUpdateForm && (
        <div className="form-container">
          <h4>✏️ Update Tool</h4>
          <input
            type="text"
            placeholder="Tool ID (required)"
            value={updateData.id}
            onChange={(e) => setUpdateData({ ...updateData, id: e.target.value })}
          />
          {Object.entries(updateData).map(([key, val]) => {
            if (key === 'id') return null;
            if (key === 'isFree') {
              return (
                <label key={key}>
                  <input
                    type="checkbox"
                    checked={val}
                    onChange={(e) =>
                      setUpdateData(prev => ({
                        ...prev,
                        [key]: e.target.checked
                      }))
                    }
                  />
                  Is Free
                </label>
              );
            }
            return (
              <input
                key={key}
                type="text"
                placeholder={key}
                value={val}
                onChange={(e) =>
                  setUpdateData(prev => ({
                    ...prev,
                    [key]: e.target.value
                  }))
                }
              />
            );
          })}
          <button onClick={handleUpdateTool}>Update Tool</button>
        </div>
      )}

      {/* Delete Tool Form */}
      {showDeleteForm && (
        <div className="form-container">
          <h4>🗑️ Delete Tool</h4>
          <input
            type="text"
            placeholder="Tool ID"
            value={deleteId}
            onChange={(e) => setDeleteId(e.target.value)}
          />
          <button onClick={handleDeleteTool}>Delete Tool</button>
        </div>
      )}

      {/* Tool Table */}
      <table className="tool-table">
        <thead>
          <tr>
            <th className="subs-hide">S.No.</th>
            <th className="subs-hide">Tool ID</th>
            <th>Name</th>
            <th>Free/Paid</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {filteredTools.map((tool,index) => (
            <tr key={tool._id}>
              <td className="subs-hide">{index + 1}</td>
              <td className="subs-hide">{tool._id}</td>
              <td>{tool.name}</td>
              <td>{tool.isFree ? 'Free' : 'Paid'}</td>
              <td>
  <button
    className="edit-btn"
    onClick={() => {
      setUpdateData({
        id: tool._id,
        name: tool.name || '',
        description: tool.description || '',
        category: tool.category || '',
        logo: tool.logo || '',
        website: tool.website || '',
        isFree: tool.isFree,
        howToUse: tool.howToUse ? tool.howToUse.join(', ') : '',
        whatItDoes: tool.whatItDoes || '',
        demoVideo: tool.demoVideo || ''
      });
      setShowUpdateForm(true);
    }}
  >
    ✏️
  </button>
</td>

              <td>
                <button className="delete-btn" onClick={() => {
                  setDeleteId(tool._id);
                  setShowDeleteForm(true);
                }}>
                  ❌
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminDashboard;
